
import React from 'react';
import { useAppContext } from '../App.jsx';
import { User, HardHat } from 'lucide-react';
import { COLORS } from '../config/constants';

const RoleSelectionScreen = () => {
    const { fullUserData, setActiveUserRole } = useAppContext();

    const userName = fullUserData?.profile_client?.name || fullUserData?.profile_servi?.name || 'Usuário';

    const backgroundStyle = {
        background: `linear-gradient(to bottom, ${COLORS.PRIMARY_BLUE}, ${COLORS.LIGHT_GRAY})`,
    };

    return (
        <div className="flex flex-col items-center justify-center h-screen p-6" style={backgroundStyle}>
            <div className="text-center mb-12">
                <h1 className="text-3xl font-bold text-white">Olá, {userName}!</h1>
                <p className="text-lg text-white/90 mt-2">Como você gostaria de entrar hoje?</p>
            </div>

            <div className="w-full max-w-sm space-y-6">
                {/* Card Cliente */}
                {fullUserData?.roles?.client && (
                    <button
                        onClick={() => setActiveUserRole('client')}
                        className="w-full flex items-center p-6 bg-white rounded-2xl shadow-lg border-2 border-transparent hover:border-blue-500 transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                    >
                        <User className="w-10 h-10 text-blue-500 mr-6" />
                        <div className="text-left">
                            <h2 className="text-xl font-bold text-gray-800">Entrar como Cliente</h2>
                            <p className="text-gray-500">Buscar e contratar serviços</p>
                        </div>
                    </button>
                )}

                {/* Card SERVI */}
                {fullUserData?.roles?.servi && (
                    <button
                        onClick={() => setActiveUserRole('servi')}
                        className="w-full flex items-center p-6 bg-white rounded-2xl shadow-lg border-2 border-transparent hover:border-blue-500 transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                    >
                        <HardHat className="w-10 h-10 text-blue-500 mr-6" />
                        <div className="text-left">
                            <h2 className="text-xl font-bold text-gray-800">Entrar como SERVI</h2>
                            <p className="text-gray-500">Gerenciar meus serviços</p>
                        </div>
                    </button>
                )}
            </div>
        </div>
    );
};

export default RoleSelectionScreen;
